<!-- Título -->
<h2 class="title">Empleados Activos</h2>
<br>
<!-- Botones, combo y barra de búsqueda -->
<app-page-acciones
  [buttonText]="'Agregar empleado'"
  [buttonIcon]="'pi pi-plus'"
  [buttonColor]="'white'"
  [textButtonColor]="'#04a563'"
  (buttonClick)="onNewRegister()"

  [buttonTextSecond]="'Carga masiva'"
  [buttonIconSecond]="'pi pi-upload'"
  [buttonColorSecond]="'#04a563'"
  [textSecondButtonColor]="'white'"
  (buttonClickSecond)="onBulkLoad()"
  [hasButtonSecond]="true"

  [hasComboAux]="false"
  [hasYearOptions]="false"
  [hasCombo]="false"
  [hasComboStatus]="false"
  
  [searchQuery]="searchTerm"
  (searchQueryChange)="onSearch($event)"
>
</app-page-acciones>

<!-- Tabs y tabla dinámica -->
<app-page-container
  [contentContainerClass]="'employees-container'"
  [tabs]="tabs"
  [displayedColumns]="displayedColumnsToShow"
  [dataSource]="dataSource"
  [actionButtons]="actionButtons"
  [headerClass]="currentHeaderClass"
  [showPreviewCard]="false"
  [isLoading]="isLoading"
  [useServerPagination]="true"
  [paginationLength]="totalElements"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [customTemplates]="{
    names: namesTemplate,
    lastNames: lastnamesTemplate,
    phoneEmergency: phoneEmergencyTemplate,
    email: emailTemplate,
    startDate: startDateTemplate
  }"
  (tabSelected)="onTabSelected($event)"
  (rowSelected)="onRowSelected($event)"
  (pageChange)="onPageChange($event)"
  [hasCheckbox]="true"
>
  <ng-template #namesTemplate let-row>
    {{ row.names | capitalize }}
  </ng-template>
  <ng-template #lastnamesTemplate let-row>
    {{ row.lastNames | capitalize }}
  </ng-template>
  <ng-template #phoneEmergencyTemplate let-row>
    +{{ row.phoneCode }} {{ row.phone }}
  </ng-template>
  <ng-template #emailTemplate let-row>
    <span class="truncate-text">{{ row.email }}</span>
  </ng-template>
  <ng-template #startDateTemplate let-row>
    {{ formatDate(row.startDate) }}
  </ng-template>
</app-page-container>

<!-- Modal del detalle -->
<!-- EmployeeEditModalComponent -->
<div class="employee-edit-modal">
  <app-employee-edit-modal
    [(visible)]="mostrarModalEditar"
    [dataToEdit]="dataToEdit"
    (visibleChange)="onDialogClose()"
    (editComplete)="onEditComplete()"
  ></app-employee-edit-modal>
</div>

<app-employee-bulk-load
  [(visible)]="mostrarModalBulkLoad"
  (registerComplete)="onBulkLoadComplete()"
></app-employee-bulk-load>

<!-- EmployeeDetailModalComponent -->
<div class="employee-detail-modal">
  <app-employee-detail-modal
    [(visible)]="mostrarModalDetalle"
    [dataToView]="dataDetail"
    (visibleChange)="onDialogDetailClose()"
  ></app-employee-detail-modal>
</div>

<!-- ModalNotPermissionComponent -->
<div class="modal-not-permission">
  <app-modal-not-permission
    [(visible)]="viewDeleted"
    [id]="employeeId"
    (visibleChange)="onDialogDetailClose()"
  ></app-modal-not-permission>
</div>
